import { EmptyStatePlaceholder } from "components/EmptyStatePlaceholder";
import { ReactComponent as EquipmentPlaceholder } from "./equipment-placeholder.svg";

export const EquipmentEmptyState: React.FC<{ className?: string }> = ({ className }) => {
    return (
        <div className={className}>
            <EmptyStatePlaceholder
                className="py-5"
                placeholderImage={<EquipmentPlaceholder />}
                title="No equipment yet"
                description="This is where you'll find all your equipment"
            />
        </div>
    );
};
